import { render } from "./ErrorSection.vue?vue&type=template&id=a328eecc"
import script from "./ErrorSection.vue?vue&type=script&lang=js"
export * from "./ErrorSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__